module.exports = __webpack_public_path__ + "static/img/logo.a941fd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 86
// module chunks = 0